export default {
  error: {
    returnToHomeButton: "رفتن به صفحه اصلی"
  },
  notFound: {
    returnToHomeButton: "رفتن به صفحه اصلی",
    title: "خطای 404",
    subtitle: "متاسفیم! صفحه مورد نظر یافت نشد.",
    description:
      "احتمال دارد آدرس URL مورد نظر خود را به اشتباه وارد کرده باشید."
  }
};
